import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import { fetchArqueos } from '../actions/arqueos'
import ErrorMessage from '../components/ErrorMessage'
import LoadingProgress from '../components/LoadingProgress'
import '../styles/CommissionsView.css'
import { currencySymbol } from '../utils/currency';

class ComissionDetailsView extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      VWPACKComission: 0.05,
      VWLAYComission: 0.03,
      VWGOComission: 0.15,
    }

  }

  componentDidMount() {
    const { client, year } = this.props.location.state;

    const currentYear = year

    const yearStart = new Date(currentYear, 0, 1);
    const formattedStartDate =
      `${yearStart.getFullYear()}-${(yearStart.getMonth() + 1).toString().padStart(2, '0')}-${yearStart.getDate().toString().padStart(2, '0')}`;
    const yearEnd = new Date(currentYear + 1, 0, 0);
    const formattedEndDate =
      `${yearEnd.getFullYear()}-${(yearEnd.getMonth() + 1).toString().padStart(2, '0')}-${yearEnd.getDate().toString().padStart(2, '0')}`;

    this.props.fetchArqueos('', client, formattedStartDate, formattedEndDate, '');
  }

  calculatePriceWithoutTaxAndComission(priceWithTax, taxRate, comissionRate) {
    // Convert tax rate from percentage to decimal
    const taxMultiplier = 1 + taxRate / 100;

    let comissionMultiplier = 1;

    comissionRate != 0 ? comissionMultiplier = comissionRate / 100 : comissionMultiplier = 1

    // Calculate price without tax and round to two decimal places
    const priceWithoutTaxAndComission = ((priceWithTax / taxMultiplier) * comissionMultiplier).toFixed(2);

    // Convert the string back to a number
    return parseFloat(priceWithoutTaxAndComission);
  }

  calculateUnitsCustomerTotals() {
    const { arqueos } = this.props;

    // Initialize an object to store monthly totals
    const monthlyTotals = {
      productTotal: 0,
      VWPACKTotal: 0,
      VWGOTotal: 0,
      VWLAYTotal: 0,
      productMonthTotal: Array(12).fill(0),
      VWPACK: Array(12).fill(0),
      VWGO: Array(12).fill(0),
      VWLAY: Array(12).fill(0),
    };

    let year = new Date();
    let customer = "";

    // Iterate through arqueos to find the ones belonging to the current customer
    arqueos.forEach(arqueo => {

      // Extract month from the timestamp
      const month = new Date(arqueo.TimeStamp).getUTCMonth();

      monthlyTotals.productTotal += (this.calculatePriceWithoutTaxAndComission(arqueo.ItemsPrices.VWPACK, arqueo.Tax, arqueo.ItemsComissions.VWPACK) || 0) + (this.calculatePriceWithoutTaxAndComission(arqueo.ItemsPrices.VWGO, arqueo.Tax, arqueo.ItemsComissions.VWGO) || 0) + (this.calculatePriceWithoutTaxAndComission(arqueo.ItemsPrices.VWLAY, arqueo.Tax, arqueo.ItemsComissions.VWLAY) || 0); monthlyTotals.VWPACKTotal += arqueo.Items.VWPACK || 0;
      monthlyTotals.VWGOTotal += arqueo.Items.VWGO || 0;
      monthlyTotals.VWLAYTotal += arqueo.Items.VWLAY || 0;
      monthlyTotals.productMonthTotal[month] += (this.calculatePriceWithoutTaxAndComission(arqueo.ItemsPrices.VWPACK, arqueo.Tax, arqueo.ItemsComissions.VWPACK) || 0) + (this.calculatePriceWithoutTaxAndComission(arqueo.ItemsPrices.VWGO, arqueo.Tax, arqueo.ItemsComissions.VWGO) || 0) + (this.calculatePriceWithoutTaxAndComission(arqueo.ItemsPrices.VWLAY, arqueo.Tax, arqueo.ItemsComissions.VWLAY) || 0);
      monthlyTotals.VWPACK[month] += arqueo.Items.VWPACK || 0;
      monthlyTotals.VWGO[month] += arqueo.Items.VWGO || 0;
      monthlyTotals.VWLAY[month] += arqueo.Items.VWLAY || 0;

      year = new Date(arqueo.TimeStamp).getFullYear();
      customer = arqueo.Customer.Fullname

    });

    return {
      monthlyTotals,
      year: year,
      customer: customer
    };
  }

  render() {
    const months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
    const { arqueos, loading, error } = this.props;
    const { year } = this.props.location.state;

    if (error) {
      return <ErrorMessage message={error.message} />;
    }

    if (!arqueos || loading) {
      return <LoadingProgress />;
    }

    const client = this.calculateUnitsCustomerTotals();

    const totalPackComission = client.monthlyTotals.VWPACKTotal * this.state.VWPACKComission;
    const totalLayComission = client.monthlyTotals.VWLAYTotal * this.state.VWLAYComission;
    const totalGoComission = client.monthlyTotals.VWGOTotal * this.state.VWGOComission;

    return (
      <div className="com-view">
        {/* Header */}
        <div className="com-header">
          <div className="header-content">
            <div className="header-text">
              <h1>
                <i className="fas fa-hand-holding-usd mr-1"></i>
                <span className="text-vw-dark">{client.customer} </span>
                <span className="text-vw-light">— {year}</span>
              </h1>
            </div>
            <div className="header-actions">
              <Link to="/comissions" className="com-btn secondary">
                <i className="fas fa-arrow-left"></i>
                <span>Volver</span>
              </Link>
            </div>
          </div>
        </div>

        {/* Annual KPI Cards */}
        <div className="com-kpi-row-4">
          <div className="com-kpi-card generated">
            <div className="kpi-icon"><i className="fas fa-coins"></i></div>
            <div className="kpi-content">
              <div className="kpi-value">{client.monthlyTotals.productTotal.toFixed(2)} {currencySymbol()}</div>
              <div className="kpi-label">Total Generado</div>
            </div>
          </div>
          <div className="com-kpi-card vwpack">
            <div className="kpi-icon"><i className="fas fa-box"></i></div>
            <div className="kpi-content">
              <div className="kpi-value">{totalPackComission.toFixed(2)} {currencySymbol()}</div>
              <div className="kpi-label">VWPACK · {client.monthlyTotals.VWPACKTotal} uds</div>
            </div>
          </div>
          <div className="com-kpi-card vwlay">
            <div className="kpi-icon"><i className="fas fa-tshirt"></i></div>
            <div className="kpi-content">
              <div className="kpi-value">{totalLayComission.toFixed(2)} {currencySymbol()}</div>
              <div className="kpi-label">VWLAY · {client.monthlyTotals.VWLAYTotal} uds</div>
            </div>
          </div>
          <div className="com-kpi-card vwgo">
            <div className="kpi-icon"><i className="fas fa-running"></i></div>
            <div className="kpi-content">
              <div className="kpi-value">{totalGoComission.toFixed(2)} {currencySymbol()}</div>
              <div className="kpi-label">VWGO · {client.monthlyTotals.VWGOTotal} uds</div>
            </div>
          </div>
        </div>

        {/* Month Grid */}
        <div className="com-detail-month-grid">
          {months.map((month, index) => {
            const packComission = client.monthlyTotals.VWPACK[index] * this.state.VWPACKComission;
            const layComission = client.monthlyTotals.VWLAY[index] * this.state.VWLAYComission;
            const goComission = client.monthlyTotals.VWGO[index] * this.state.VWGOComission;
            const monthTotalComission = packComission + layComission + goComission;

            return (
              <div key={month} className="com-detail-month-card">
                <div className="com-detail-month-header">
                  <div className="com-detail-month-title">
                    <i className="fas fa-calendar-day"></i> {month}
                  </div>
                  <div className="com-detail-month-summary">
                    {client.monthlyTotals.productMonthTotal[index].toFixed(2)} {currencySymbol()} generado
                  </div>
                </div>
                <div className="com-detail-product-table">
                  <div className="com-detail-product-header">
                    <div className="com-detail-col col-product">Producto</div>
                    <div className="com-detail-col col-units">Unidades</div>
                    <div className="com-detail-col col-rate">Tasa</div>
                    <div className="com-detail-col col-comission">Comisión</div>
                  </div>
                  <div className="com-detail-product-row">
                    <div className="com-detail-col col-product">VWPACK</div>
                    <div className="com-detail-col col-units">{client.monthlyTotals.VWPACK[index]} uds</div>
                    <div className="com-detail-col col-rate">{(this.state.VWPACKComission * 100).toFixed(0)}%</div>
                    <div className="com-detail-col col-comission">{packComission.toFixed(2)} {currencySymbol()}</div>
                  </div>
                  <div className="com-detail-product-row">
                    <div className="com-detail-col col-product">VWLAY</div>
                    <div className="com-detail-col col-units">{client.monthlyTotals.VWLAY[index]} uds</div>
                    <div className="com-detail-col col-rate">{(this.state.VWLAYComission * 100).toFixed(0)}%</div>
                    <div className="com-detail-col col-comission">{layComission.toFixed(2)} {currencySymbol()}</div>
                  </div>
                  <div className="com-detail-product-row">
                    <div className="com-detail-col col-product">VWGO</div>
                    <div className="com-detail-col col-units">{client.monthlyTotals.VWGO[index]} uds</div>
                    <div className="com-detail-col col-rate">{(this.state.VWGOComission * 100).toFixed(0)}%</div>
                    <div className="com-detail-col col-comission">{goComission.toFixed(2)} {currencySymbol()}</div>
                  </div>
                </div>
                <div className="com-detail-month-totals">
                  <div className="com-detail-totals-label">Total comisiones</div>
                  <div className="com-detail-totals-generated">{client.monthlyTotals.productMonthTotal[index].toFixed(2)} {currencySymbol()} gen.</div>
                  <div className="com-detail-totals-comission">{monthTotalComission.toFixed(2)} {currencySymbol()}</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  arqueos: state.arqueos.arqueos,
  error: state.arqueos.error,
  loading: state.arqueos.loading,
  role: state.auth.role,
  form: state.form
})

const mapDispatchToProps = dispatch => ({
  fetchArqueos: bindActionCreators(fetchArqueos, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(ComissionDetailsView)

